<div class="card parentcard p-3 overflow-y-auto">
  <div class="container-fluid" id="container">
    
    <!-- Step 3 Section -->
    <div class="row header-txt m-0">
      <h6 class="pt-4">
        <strong>Step 3:</strong>
        <p class="">Define Data Volume</p>
        <hr />
      </h6>
    </div>
    
    <div class="row g-2 rowrow border">
      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1"></div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 pt-2">
        <strong>
          <label for="rowCount">Specify Row Count:
            <i class="bi bi-info-circle text-primary ms-1" 
               data-bs-toggle="tooltip" 
               title="Enter the number of synthetic data rows to generate. Limit - (1-50000)"></i>
          </label>
        </strong>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xl-5 col-xxl-5">
        <div class="input-box">
          <i class="bi bi-table"></i>
          <input #rowsInput 
            id="rowCount"
            type="number" 
            min="1" 
            max="50000" 
            step="1" 
            placeholder="Examples: 10, 100" 
            required />
        </div>
      </div>
    </div>
  
    <!-- Step 4 Section -->
    <div class="row header-txt m-0">
      <h6 class="pt-4">
        <strong>Step 4:</strong>
        <p class="">Choose Additional Options</p>
        <hr />
      </h6>
    </div>

    <div class="row cardrow">

      <!-- DMSH Service Option -->
      <div class="col-md-6">
        <div class="row g-2 cardcol border">
          <div class="option-item">
            <div class="mb-2">
              <i class="bi bi-cloud-upload text-primary option-icon"></i>
              <h6 class="fw-bold mb-1">DMSH Service</h6>
              <p class="text-muted small mb-3">Trigger DMSH shared job in matillion using SQS Message for the selected table(s).</p>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dmshService" [(ngModel)]="mat_box" name="matbox">
              <label class="form-check-label" for="dmshService">Enable DMSH Service</label>
            </div>
            
            <!-- System Name input field - appears only when DMSH is enabled -->
            <div class="input-box mt-3" *ngIf="mat_box">
              <i class="bi bi-pc-display"></i>
              <input type="text" placeholder="System Name" [(ngModel)]="dmshSystemName" name="dmshSystemName" required>
              <small class="text-danger d-block" *ngIf="mat_box && dmshSystemName.trim() === ''">*Required</small>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Download Data Option -->
      <div class="col-md-6">
        <div class="row g-2 cardcol2 border">
          <div class="option-item">
            <div class="mb-2">
              <i class="bi bi-download text-primary option-icon"></i>
              <h6 class="fw-bold mb-1">Download Data</h6>
              <p class="text-muted small mb-3">Download the generated data directly to your device as a zip file.</p>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="downloadData" [(ngModel)]="ful_dd" name="ddbox">
              <label class="form-check-label" for="downloadData">Enable Download</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row float-end justify-content-end">
      <button class="btn btn-primary nxtbtn" (click)="Codereview()">
        Generate Script
        <i class="bi bi-code-square"></i>
      </button>
    </div>
  </div>

  <!-- Toast Container -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100">
    <ngb-toast
      *ngFor="let toast of toastService.getToasts()"
      [autohide]="toast.options?.autohide ?? true"
      [delay]="toast.options?.delay ?? 5000"
      [class]="toast.options?.classname"
      (hidden)="toastService.remove(toast)"
    >
      <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
      </ng-template>
      <ng-template #text>{{ toast.textOrTpl }}</ng-template>
    </ngb-toast>
  </div>
</div>